import React, { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { Box, Typography, Grid, Divider, Container, Dialog, DialogTitle, DialogActions, Button } from '@mui/material'
import Logo from '../../assets/images/oujat.png'
import SocialMedia1 from 'src/assets/images/SocialIcon1.png'
import SocialMedia2 from 'src/assets/images/SocialIcon2.png'
import SocialMedia3 from 'src/assets/images/SocialIcon3.png'
import SocialMedia4 from 'src/assets/images/SocialIcon4.png'
import SocialMedia5 from 'src/assets/images/SocialIcon5.png'
import SocialMedia6 from 'src/assets/images/SocialIcon6.png'
import SocialMedia7 from 'src/assets/images/SocialIcon7.png'
import SocialMedia8 from 'src/assets/images/SocialIcon8.png'
import SocialMedia9 from 'src/assets/images/SocialIcon9.png'
import SocialMedia10 from 'src/assets/images/SocialIcon10.png'
import SocialMedia11 from 'src/assets/images/SocialIcon11.png'
import SocialMedia12 from 'src/assets/images/SocialIcon12.png'
import SocialMedia13 from 'src/assets/images/SocialIcon13.png'
import SocialMedia14 from 'src/assets/images/SocialIcon14.png'
import SocialMedia15 from 'src/assets/images/SocialIcon15.png'
import SocialMedia16 from 'src/assets/images/SocialIcon16.png'
import SocialMedia17 from 'src/assets/images/SocialIcon17.png'
import FacebookFooterIcon from 'src/@core/components/icons/FacebookFooterIcon'
import LinkdinFooterIcon from 'src/@core/components/icons/LinkdinFooterIcon'
import InstragramFooterIcon from 'src/@core/components/icons/InstragramFooterIcon'
import YoutubeIcon from 'src/@core/components/icons/YoutubeIcon'
import useCustomTranslation from 'src/@core/hooks/useCustomTranslation'
import Translations from 'src/layouts/components/Translations'

const Footer = () => {
  const translation = useCustomTranslation()
  const location = useLocation()
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()

  const media = [
    {
      image: SocialMedia1
    },
    {
      image: SocialMedia2
    },
    {
      image: SocialMedia3
    },
    {
      image: SocialMedia4
    },
    {
      image: SocialMedia5
    },
    {
      image: SocialMedia6
    },
    {
      image: SocialMedia7
    },
    {
      image: SocialMedia8
    },
    {
      image: SocialMedia9
    },
    {
      image: SocialMedia10
    },
    {
      image: SocialMedia11
    },
    {
      image: SocialMedia12
    },
    {
      image: SocialMedia13
    },
    {
      image: SocialMedia14
    },
    {
      image: SocialMedia15
    },
    {
      image: SocialMedia16
    },
    {
      image: SocialMedia17
    }
  ]

  const links = [
    { path: '/policies-rules-page', label: translation.translate('footer.Policies.Policies and Rules') },
    { path: '/legal-notice-page', label: translation.translate('footer.Policies.Legal Notice') },
    { path: '/service-listing-policy-page', label: translation.translate('footer.Policies.Service Listing Policy') },
    { path: '/privacy-policy-page', label: translation.translate('footer.Policies.Privacy Policy') },
    { path: '/terms-of-use-page', label: translation.translate('footer.Policies.Terms of Use') }
  ]

  const handleOpen = () => setOpen(true)
  const handleClose = url => {
    setOpen(false)
    if (url) window.open(url, '_blank', 'noopener,noreferrer')
  }

  const handleLogoClick = e => {
    if (location.pathname === '/landing-page') {
      e.preventDefault() // stop navigation
      window.scrollTo({ top: 0, behavior: 'smooth' })
    } else {
      navigate('/landing-page')
    }
  }

  return (
    <>
      <Box
        sx={{
          bgcolor: '#F6F6F6',
          px: { xs: 1, md: 3, lg: 3 },
          py: { xs: 1, md: 3, lg: 3 }
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mt: '30px', mb: '30px' }}>
          <Link to='/landing-page' onClick={handleLogoClick}>
            <img src={Logo} alt='logo' sx={{ mt: '35x' }} />
          </Link>
        </Box>
        <Container maxWidth='xl'>
          <Grid container spacing={10}>
            <Grid item xs={12} sm={6} md={2}>
              <Typography
                variant='fm-p1'
                sx={{
                  fontWeight: 500,
                  color: 'common.black'
                }}
              >
                <Translations text={translation.translate('footer.Get support.Get support')} />
              </Typography>
              <Box sx={{ my: 3 }}>
                <Link to='/help-center' style={{ textDecoration: 'none' }}>
                  <Typography
                    variant='fm-p1'
                    sx={{
                      fontWeight: 500,
                      color: location.pathname === '/help-center' ? '#FC5722' : '#8E8E8E'
                    }}
                  >
                    <Translations text={translation.translate('footer.Get support.Help center')} />
                  </Typography>
                </Link>
              </Box>
              <Box sx={{ my: 3 }}>
                <Link to='/contact-us' style={{ textDecoration: 'none' }}>
                  <Typography
                    variant='fm-p1'
                    sx={{
                      fontWeight: 500,
                      color: location.pathname === '/contact-us' ? '#FC5722' : '#8E8E8E'
                    }}
                  >
                    <Translations text={translation.translate('footer.Company.Contact Us')} />
                  </Typography>
                </Link>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Typography
                variant='fm-p1'
                sx={{
                  fontWeight: 500,
                  color: 'common.black'
                }}
              >
                <Translations text={translation.translate('footer.Payments.Payments and Protections')} />
              </Typography>
              <Box sx={{ my: 3 }}>
                <Link to='/securedpayments' style={{ textDecoration: 'none' }}>
                  <Typography
                    variant='fm-p1'
                    sx={{
                      fontWeight: 500,
                      color: location.pathname === '/securedpayments' ? '#FC5722' : '#8E8E8E'
                    }}
                  >
                    <Translations text={translation.translate('footer.Payments.Secured and easy payments')} />
                  </Typography>
                </Link>
              </Box>
              <Link to='/oujat-digital-wallet-page' style={{ textDecoration: 'none' }}>
                <Typography
                  variant='fm-p1'
                  sx={{
                    fontWeight: 500,
                    color: location.pathname === '/oujat-digital-wallet-page' ? '#FC5722' : '#8E8E8E'
                  }}
                >
                  <Translations text={translation.translate('footer.Payments.Oujat Digital Wallet')} />
                </Typography>
              </Link>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <Typography
                variant='fm-p1'
                sx={{
                  fontWeight: 500,
                  color: 'common.black'
                }}
              >
                <Translations text={translation.translate('footer.Oujat.com.Ship on Oujat.com')} />
              </Typography>
              <Box sx={{ my: 3 }}>
                <Link to='/customerstype' style={{ textDecoration: 'none' }}>
                  <Typography
                    variant='fm-p1'
                    sx={{
                      fontWeight: 500,
                      color: location.pathname === '/customerstype' ? '#FC5722' : '#8E8E8E'
                    }}
                  >
                    <Translations text={translation.translate('footer.Oujat.com.The customers')} />
                  </Typography>
                </Link>
              </Box>
              <Box sx={{ my: 3 }}>
                <Link to='/agentcategories' style={{ textDecoration: 'none' }}>
                  <Typography
                    variant='fm-p1'
                    sx={{
                      fontWeight: 500,
                      color: location.pathname === '/agentcategories' ? '#FC5722' : '#8E8E8E'
                    }}
                  >
                    <Translations text={translation.translate('footer.Oujat.com.The Agents')} />
                  </Typography>
                </Link>
              </Box>
              <Box sx={{ my: 3 }}>
                <Link to='/oujatreads' style={{ textDecoration: 'none' }}>
                  <Typography
                    variant='fm-p1'
                    sx={{
                      fontWeight: 500,
                      color: location.pathname === '/oujatreads' ? '#FC5722' : '#8E8E8E'
                    }}
                  >
                    <Translations text={translation.translate('footer.Oujat.com.Oujat.com Reads')} />
                  </Typography>
                </Link>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Typography
                variant='fm-p1'
                sx={{
                  fontWeight: 500,
                  color: 'common.black'
                }}
              >
                <Translations text={translation.translate('footer.Become an agent.Become an agent')} />
              </Typography>
              <Box sx={{ my: 3 }}>
                <Link to='/how-it-works' style={{ textDecoration: 'none' }}>
                  <Typography
                    variant='fm-p1'
                    sx={{
                      fontWeight: 500,
                      color: location.pathname === '/how-it-works' ? '#FC5722' : '#8E8E8E'
                    }}
                  >
                    <Translations text={translation.translate('footer.Become an agent.How it works')} />
                  </Typography>
                </Link>
              </Box>
              <Box sx={{ my: 3 }}>
                <Typography
                  variant='fm-p1'
                  sx={{ fontWeight: 500, color: '#8E8E8E', cursor: 'pointer' }}
                  onClick={handleOpen}
                >
                  <Translations text={translation.translate('footer.Become an agent.Register/Login')} />
                </Typography>
                {/* Dialog Box */}
                <Dialog
                  open={open}
                  onClose={() => handleClose()}
                  aria-labelledby='alert-dialog-title'
                  aria-describedby='alert-dialog-description'
                >
                  <DialogTitle
                    id='alert-dialog-title'
                    sx={{ textAlign: 'center', fontSize: '1.5rem', fontWeight: 'bold' }}
                  >
                    Login
                  </DialogTitle>

                  <DialogActions sx={{ justifyContent: 'center' }}>
                    <Button
                      variant='contained'
                      color='primary'
                      target='_blank'
                      onClick={() => handleClose('https://www.customer.oujat.com/login')}
                      sx={{
                        textDecoration: 'none',
                        width: '100%'
                      }}
                    >
                      Customer
                    </Button>
                    <Button
                      variant='contained'
                      color='primary'
                      target='_blank'
                      onClick={() => handleClose('https://www.agent.oujat.com/login')}
                      sx={{
                        textDecoration: 'none',
                        width: '100%'
                      }}
                    >
                      Agent
                    </Button>
                  </DialogActions>
                </Dialog>
              </Box>
              <Box sx={{ my: 3 }}>
                <Link to='/subscription-page' style={{ textDecoration: 'none' }}>
                  <Typography
                    variant='fm-p1'
                    sx={{
                      fontWeight: 500,
                      color: location.pathname === '/subscription-page' ? '#FC5722' : '#8E8E8E'
                    }}
                  >
                    <Translations text={translation.translate('footer.Become an agent.Subscription package')} />
                  </Typography>
                </Link>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <Typography
                variant='fm-p1'
                sx={{
                  fontWeight: 500,
                  color: 'common.black'
                }}
              >
                <Translations text={translation.translate('footer.Company.Company')} />
              </Typography>
              <Box sx={{ my: 3 }}>
                <Link to='/aboutus' style={{ textDecoration: 'none' }}>
                  <Typography
                    variant='fm-p1'
                    sx={{
                      fontWeight: 500,
                      color: location.pathname === '/aboutus' ? '#FC5722' : '#8E8E8E'
                    }}
                  >
                    <Translations text={translation.translate('footer.Company.About Oujat.com')} />
                  </Typography>
                </Link>
              </Box>
              <Box sx={{ my: 3 }}>
                <Link to='/career' style={{ textDecoration: 'none' }}>
                  <Typography
                    variant='fm-p1'
                    sx={{
                      fontWeight: 500,
                      color: location.pathname === '/career' ? '#FC5722' : '#8E8E8E'
                    }}
                  >
                    <Translations text={translation.translate('footer.Company.Career')} />
                  </Typography>
                </Link>
              </Box>
            </Grid>
            <Grid item container xs={12} spacing={2}>
              {media?.map((i, index) => (
                <Grid item key={index}>
                  <img src={i?.image} alt='' />
                </Grid>
              ))}
            </Grid>
            <Grid item xs={12} display='flex' alignItems={'center'} gap={3}>
              <Typography
                variant='fm-h6'
                sx={{
                  fontWeight: 500,
                  color: 'common.black'
                }}
              >
                <Translations text={translation.translate('footer.Company.Follow Us On')} />
              </Typography>
              <Box sx={{ display: 'flex', mt: 2, gap: 3 }}>
                <Link
                  target='_blank'
                  to='https://www.facebook.com/Oujattechnologies?mibextid=ZbWKwL'
                  style={{ textDecoration: 'none' }}
                >
                  <FacebookFooterIcon />
                </Link>
                <Link
                  to='https://www.linkedin.com/company/oujat/'
                  target='_blank'
                  style={{ textDecoration: 'none' }}
                >
                  <LinkdinFooterIcon />
                </Link>
                <Link
                  target='_blank'
                  to='https://www.youtube.com/@Oujat-marketplace'
                  style={{ textDecoration: 'none' }}
                >
                  <YoutubeIcon />
                </Link>
                <Link
                  target='_blank'
                  to='http://www.instagram.com/oujatmarketplace'
                  style={{ textDecoration: 'none' }}
                >
                  <InstragramFooterIcon />
                </Link>
              </Box>
            </Grid>
          </Grid>
          <Divider sx={{ borderColor: '#AAAAAA' }} />
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: { xs: 3, md: 0 },
              p: 3
            }}
          >
            <Typography
              sx={{
                fontSize: '16px',
                lineHeight: '24px',
                color: '#5E5E5E',
                textAlign: { xs: 'center', sm: 'left' }
              }}
            >
              {translation.translate('footer.Copyright')} {new Date().getFullYear()},{' '}
              {translation.translate('footer.All Rights Reserved')}
            </Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                alignItems: { xs: 'center', sm: 'flex-start' },
                gap: { xs: 2, sm: 4 }
              }}
            >
              {links.map(link => {
                const isActive = location.pathname === link.path
                return (
                  <Link
                    key={link.path}
                    to={isActive ? '#' : link.path}
                    style={{ textDecoration: 'none', pointerEvents: isActive ? 'none' : 'auto' }}
                  >
                    <Typography
                      variant='fm-p2'
                      sx={{
                        fontWeight: 500,
                        color: isActive ? '#FC5722' : '#5E5E5E',
                        textAlign: { xs: 'center', sm: 'left' }
                      }}
                    >
                      {link.label}
                    </Typography>
                  </Link>
                )
              })}
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  )
}

export default Footer
